import React from "react";
import { Card } from "react-bootstrap";
import IconTable from "components/IconTable";

const statusLabels = {
  ACTIVE: "Active",
  NO_LOGIN: "No Login",
  MID_APP: "Mid App",
  YELLOW: "Yellow",
  RED: "Red",
  FUNDED: "Funded",
  TOTAL: "Total",
};

type StatusKey = keyof typeof statusLabels;

interface AccountStatusRow {
  status: StatusKey;
  count: number;
  // optional: the TOTAL row pushed by the parent omits percentOfTotal
  percentOfTotal?: string;
}

interface Props {
  accountStatusData: AccountStatusRow[];
}

const AccountStatusSummaryTable = ({ accountStatusData }: Props) => {
  return (
    <Card>
      <Card.Header>
        <h4>Account Status Summary</h4>
      </Card.Header>
      <Card.Body>
        <IconTable
          columns={[
            {
              label: "Status",
              key: "status",
              format: (status) => {
                return statusLabels[status as StatusKey];
              },
            },
            { label: "Count", key: "count" },
            { label: "Percent of Total", key: "percentOfTotal" },
          ]}
          data={accountStatusData}
        />
      </Card.Body>
    </Card>
  );
};

export default AccountStatusSummaryTable;
